import React from "react";
import { EyeOff } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

/**
 * Vises kun for brukere som er skjul-bannet. Advarer dem om at innholdet
 * deres er usynlig for andre inntil banen utløper.
 */
export default function ShadowbanBanner() {
  const { user } = useAuth();
  if (!user || !user.shadowbanned_until) return null;
  const until = new Date(user.shadowbanned_until);
  if (isNaN(until.getTime()) || until.getTime() < Date.now()) return null;
  const untilStr = until.toLocaleDateString("nb-NO", {
    day: "numeric", month: "long", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
  return (
    <div className="w-full bg-[var(--magenta)]/15 border-y border-[var(--magenta)]/50" data-testid="shadowban-banner">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-start gap-3">
        <EyeOff className="h-5 w-5 text-[var(--magenta)] shrink-0 mt-0.5" />
        <div className="flex-1 text-sm">
          <div className="font-fraunces italic text-[var(--cream)] mb-0.5">
            Kontoen din er skjul-bannet av moderator
          </div>
          <p className="text-[var(--cream-soft)] text-xs leading-relaxed">
            Innholdet ditt (profil, poster, Glimt, kommentarer) er usynlig for andre brukere.
            Du kan fortsatt logge inn og se ditt eget innhold. Utløper: <strong className="text-[var(--cream)]">{untilStr}</strong>.
            {user.shadowban_reason && (
              <> Grunn: <em className="text-[var(--cream)]">{user.shadowban_reason}</em>.</>
            )}
            {" "}Ta kontakt med support hvis du mener dette er en feil.
          </p>
        </div>
      </div>
    </div>
  );
}
